import Header from '@legacy-components/react/V5/Header/HeaderContainer';
import { Box, Container, Link, Stack, Typography } from '@mui/material';
import image1 from '@images/403-image-1.png';
import image2 from '@images/403-image-2.png';
import { ReactComponent as Hexagon } from '@images/icons/hexagon.svg';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Props = any;

export default function Code403(props: Props): JSX.Element {
  const IMAGE_WIDTH_1 = 380;
  const IMAGE_WIDTH_2 = 290;

  const renderImages = () => (
    <Stack position="relative" direction="row">
      <Box>
        <Box
          component="img"
          boxShadow="0px 5px 15px 0px #0000004D"
          borderRadius="10px"
          width={IMAGE_WIDTH_1}
          src={image1}
        />
      </Box>

      <Box>
        <Box
          component="img"
          marginTop="60%"
          marginLeft="-50%"
          boxShadow="0px 5px 15px 0px #0000004D"
          borderRadius="10px"
          width={IMAGE_WIDTH_2}
          src={image2}
        />
      </Box>

      <Box position="absolute" zIndex={-1} right="32%" top="20%">
        <Box position="relative">
          <Box
            width={120}
            height={120}
            borderRadius="50%"
            bgcolor="#27BED8"
            sx={{ mixBlendMode: 'multiply' }}
          />

          <Box position="absolute" top="-48px" right="-18px">
            <Hexagon />
          </Box>
        </Box>
      </Box>
    </Stack>
  );

  const renderContent = () => (
    <Stack spacing={2}>
      <Typography variant="h1" fontWeight={400} fontSize={36}>
        This resource is currently unavailable.
      </Typography>

      <Typography variant="subtitle1">
        It looks like you don’t have permission to access this resource. This
        could be because of account permissions. Please ensure you’re{' '}
        <Link
          underline="none"
          href={`${process.env.REACT_APP_USER_MANAGEMENT_URL}/login`}
        >
          logged in
        </Link>{' '}
        with your BetterLesson account.
      </Typography>

      <Typography variant="subtitle1" fontWeight={400}>
        Need Help?{' '}
        <Link
          underline="none"
          target="_blank"
          href="https://betterlesson.atlassian.net/servicedesk/customer/portal/2/group/4"
        >
          Contact our help desk.
        </Link>
      </Typography>
    </Stack>
  );

  return (
    <div className="code-404">
      <Header {...props} page="StrategyBrowser" />

      <Container>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          py={8}
          alignItems="center"
        >
          {renderImages()}
          {renderContent()}
        </Stack>
      </Container>
    </div>
  );
}
